<template>
	<DropdownCustom ref="dropdownCustom" :toggleIcon="false" equalWidth>
		<div class="show-content">
			<span @click.stop="beforeDate"><i class="fa fa-caret-left"></i></span>
			<span>{{displayLabel}}</span>
			<span @click.stop="afterDate"><i class="fa fa-caret-right"></i></span>
		</div>
		<div class="accountDateChoose" slot="content">
			<div class="range-mode" v-if="range">
				<span class="text-hover" :class="{selected: selectingPart==='start'}" @click="selectingPart='start'">开始期间</span>
				<span class="text-hover" :class="{selected: selectingPart==='end'}" @click="selectingPart='end'">结束期间</span>
			</div>
			<Row type="flex" v-if="years.length > 1">
				<Cell>
					<div class="text-hover" :class="{selected:selectedYear===y}" @click="selectedYear=y" v-for="y in years" :key="y" style="padding: 5px 10px;">{{y}}年</div>
				</Cell>
				<Cell :flex="1" class="split-line">
					<ul class="list-item" v-for="y in years" v-if="selectedYear===y">
						<li v-for="month in checkDateObject[y]" :key="y+month" @click="changVal(y,month)" :class="{'selected':selected(y+'-'+month)}">
							第{{month}}期
						</li>
					</ul>
				</Cell>
			</Row>
			<ul class="list-item" v-else>
				<li v-for="c in User.checkoutList" :key="c.id" @click="changVal(c.checkYear,c.checkMonth)" :class="{'selected':selected(c.checkYear+'-'+c.checkMonth)}">
					{{c.checkYear}}年第{{c.checkMonth}}期
				</li>
			</ul>
		</div>
	</DropdownCustom>
</template>

<script>
	import {mapState} from 'vuex'
	import moment from 'moment'

	export default {
		name: "AccountDateChoose",
		props: {
			value: [String, Object],
			range: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			...mapState(['currentAccountSets', 'User']),
			checkDateObject() {
				let data = {};
				this.User.checkoutList.forEach(item => {
					if (!data[item.checkYear]) {
						data[item.checkYear] = [];
					}
					data[item.checkYear].push(item.checkMonth);
				});
				Object.keys(data).forEach((value) => {
					data[value] = data[value].sort((a, b) => a - b);
				});
				return data;
			},
			years() {
				return Object.keys(this.checkDateObject).sort((a, b) => b - a);
			},
			displayLabel() {
				if (!this.range) {
					return this.formatPeriod(this.accountDate);
				}
				return `${this.formatPeriod(this.rangeValue.startDate)} - ${this.formatPeriod(this.rangeValue.endDate)}`;
			}
		},
		data() {
			return {
				selectedYear: null,
				accountDate: null,
				rangeValue: {
					startDate: null,
					endDate: null
				},
				selectingPart: 'start',
				syncingFromParent: false
			}
		},
		watch: {
			accountDate(val) {
				if (!this.range) {
					this.$emit('input', val);
				}
			},
			rangeValue: {
				handler(val) {
					if (this.range && !this.syncingFromParent) {
						const normalized = this.normalizeRangeValue(val);
						this.$emit('input', normalized);
					}
				},
				deep: true
			},
			value(val) {
				this.syncFromValue(val);
			}
		},
		methods: {
			formatPeriod(date) {
				if (!date) {
					return '';
				}
				return moment(date).format("YYYY年第MM期");
			},
			normalizePeriodDate(years, months) {
				return moment({years, months: months - 1, days: 1}).endOf('month').format('YYYY-MM-DD');
			},
			normalizeToMonthEnd(date) {
				if (!date) {
					return null;
				}
				return moment(date).endOf('month').format('YYYY-MM-DD');
			},
			normalizeRangeValue(val) {
				const fallback = this.normalizeToMonthEnd(this.currentAccountSets && this.currentAccountSets.currentAccountDate);
				const startDate = this.normalizeToMonthEnd(val && val.startDate ? val.startDate : fallback);
				const endDate = this.normalizeToMonthEnd(val && val.endDate ? val.endDate : fallback);
				if (moment(startDate).isAfter(endDate)) {
					return {
						startDate: endDate,
						endDate: startDate
					};
				}
				return {
					startDate,
					endDate
				};
			},
			isSameRange(a, b) {
				return !!a && !!b && a.startDate === b.startDate && a.endDate === b.endDate;
			},
			syncFromValue(val) {
				const fallback = this.normalizeToMonthEnd(this.currentAccountSets && this.currentAccountSets.currentAccountDate);
				if (!this.range) {
					const nextValue = this.normalizeToMonthEnd(val || fallback);
					if (this.accountDate !== nextValue) {
						this.accountDate = nextValue;
					}
					return;
				}
				const normalized = this.normalizeRangeValue(val || {
					startDate: fallback,
					endDate: fallback
				});
				if (this.isSameRange(this.rangeValue, normalized)) {
					return;
				}
				this.syncingFromParent = true;
				this.rangeValue = normalized;
				this.$nextTick(() => {
					this.syncingFromParent = false;
				});
			},
			changVal(years, months) {
				const selectedDate = this.normalizePeriodDate(years, months);
				if (!this.range) {
					this.accountDate = selectedDate;
					this.$refs.dropdownCustom.hide();
					return;
				}
				if (this.selectingPart === 'start') {
					const endDate = this.rangeValue.endDate;
					this.rangeValue.startDate = selectedDate;
					if (moment(selectedDate).isAfter(endDate)) {
						this.rangeValue.endDate = selectedDate;
					}
					this.selectingPart = 'end';
				} else {
					const startDate = this.rangeValue.startDate;
					this.rangeValue.endDate = selectedDate;
					if (moment(selectedDate).isBefore(startDate)) {
						this.rangeValue.startDate = selectedDate;
					}
					this.$refs.dropdownCustom.hide();
				}
			},
			selected(m) {
				if (!this.range) {
					return moment(this.accountDate).format('YYYY-M') === m;
				}
				const candidate = moment(m, 'YYYY-M');
				const start = moment(this.rangeValue.startDate).startOf('month');
				const end = moment(this.rangeValue.endDate).endOf('month');
				return candidate.isBetween(start, end, 'month', '[]');
			},
			beforeDate() {
				let check = this.User.checkoutList[this.User.checkoutList.length - 1];
				let min = moment(check.checkYear + '-' + check.checkMonth).startOf('month');
				if (!this.range) {
					let d = moment(this.accountDate).add(-1, "M");
					if (d.isSameOrAfter(min)) {
						this.accountDate = d.endOf('month').format('YYYY-MM-DD');
					}
					return;
				}
				let start = moment(this.rangeValue.startDate).add(-1, "M");
				let end = moment(this.rangeValue.endDate).add(-1, "M");
				if (start.isSameOrAfter(min)) {
					this.rangeValue.startDate = start.endOf('month').format('YYYY-MM-DD');
					this.rangeValue.endDate = end.endOf('month').format('YYYY-MM-DD');
				}
			},
			afterDate() {
				let check = this.User.checkoutList[0];
				let max = moment(check.checkYear + '-' + check.checkMonth).endOf('month');
				if (!this.range) {
					let d = moment(this.accountDate).add(1, "M");
					if (d.isSameOrBefore(max)) {
						this.accountDate = d.endOf('month').format('YYYY-MM-DD');
					}
					return;
				}
				let start = moment(this.rangeValue.startDate).add(1, "M");
				let end = moment(this.rangeValue.endDate).add(1, "M");
				if (end.isSameOrBefore(max)) {
					this.rangeValue.startDate = start.endOf('month').format('YYYY-MM-DD');
					this.rangeValue.endDate = end.endOf('month').format('YYYY-MM-DD');
				}
			},
		},
		mounted() {
			this.syncFromValue(this.value);
			if (!this.range && !this.accountDate) {
				this.accountDate = this.normalizeToMonthEnd(this.currentAccountSets && this.currentAccountSets.currentAccountDate);
			}
			if (this.range && (!this.rangeValue.startDate || !this.rangeValue.endDate)) {
				const fallback = this.normalizeToMonthEnd(this.currentAccountSets && this.currentAccountSets.currentAccountDate);
				this.rangeValue = {
					startDate: fallback,
					endDate: fallback
				};
			}
			this.selectedYear = this.years[0];
		}
	}
</script>

<style lang="less">
	.show-content {
		background: @primary-color;
		color: @white-color;
		cursor: pointer;
		border-radius: @border-radius;

		span {
			padding: 5px 10px;
			display: inline-block
		}
	}

	.accountDateChoose {
		overflow-y: auto;

		.range-mode {
			display: flex;
			gap: 10px;
			padding: 8px 10px;
			border-bottom: 1px solid #e6e6e6;

			span {
				padding: 2px 6px;
				border-radius: 4px;
			}
		}

		div.selected {
			border-bottom: 1px solid @primary-color;
			color: @primary-color;
			font-weight: bold;
		}

		.split-line {
			border-left: 1px solid @primary-color;
		}

		.list-item {
			li {
				padding: 5px 20px;

				&:hover {
					background-color: #F0F6FF;
					cursor: pointer;
				}

				&.selected {
					background: @primary-color;
					color: @white-color;
				}
			}
		}
	}
</style>
